import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { EntityApiService } from "../../../../shared/store/entity-store/entity-api.service";
import { environment } from "../../../../../environments/environment";
import { Checklist } from "../../models/checklist.model";
import { Bundle } from "../../models/bundle.model";
import { Poste } from "../../../production/models/poste.model";

@Injectable({ providedIn: "root" })
export class ChecklistApiService implements EntityApiService<Checklist> {
  http = inject(HttpClient);

  loadOne(id: string): Observable<Checklist> {
    return this.http.get<Checklist>(
      `${environment.api()}/checklist/eager/id/${id}`,
    );
  }

  create(entity: Checklist): Observable<Checklist> {
    return this.http.post<Checklist>(`${environment.api()}/checklist`, entity);
  }

  remove(id: string): Observable<string> {
    return this.http
      .delete(`${environment.api()}/checklist/id/${id}`)
      .pipe(map((e) => id));
  }

  update(entity: Checklist): Observable<Checklist> {
    return this.http.post<Checklist>(`${environment.api()}/checklist`, entity);
  }

  buildChecklistForOpe(
    checklist: Checklist,
    ope: Poste,
  ): Observable<Checklist> {
    return this.http.post<Checklist>(`${environment.api()}/checklist/build`, {
      ope,
      checklist,
    });
  }

  buildChecklist(checklist: Checklist): Observable<Checklist> {
    return this.http.post<Checklist>(
      `${environment.api()}/checklist/build_simple`,
      checklist,
    );
  }

  loadAll(): Observable<Checklist[]> {
    throw new Error("Method not implemented.");
  }

  loadByListId(listId: string) {
    return this.http.get<Checklist[]>(
      `${environment.api()}/checklist/listId/${listId}`,
    );
  }

  duplicate(cl: Checklist): Observable<Checklist> {
    return this.http.post<Checklist>(
      `${environment.api()}/checklist/duplicate`,
      cl,
    );
  }

  saveAll(entities: Checklist[]): Observable<Checklist[]> {
    return this.http.post<Checklist[]>(
      `${environment.api()}/checklist/multiple`,
      { checklists: entities },
    );
  }

  commit(cl: Checklist) {
    return this.http.post<Bundle>(`${environment.api()}/ws/checklist`, cl);
  }

  deleteDone(id: string) {
    return this.http.delete<Bundle>(`${environment.api()}/ws/done/${id}`);
  }

  loadBundleFor(listId: string, date: string, dateFin?: string) {
    return this.http.get<Bundle>(
      `${environment.api()}/ws/bundle/list/${listId}/${date}/${dateFin}`,
    );
  }

  loadChecklistsForOf(ofId: string) {
    return this.http.get<Checklist[]>(
      `${environment.api()}/checklist/ofId/${ofId}`,
    );
  }

  loadBundleById(bundleId: string) {
    return this.http.get<Bundle>(
      `${environment.api()}/ws/bundle/id/${bundleId}`,
    );
  }
}
